import {
  COMMENT_POP,
  COMMUNITY_AUTHCODE,
  COMMUNITY_CATEGORY,
  COMMUNITY_COMMNET_DELETE,
  COMMUNITY_COMMNET_INSERT,
  COMMUNITY_COMMNET_LIST,
  COMMUNITY_COMMNET_UPDATE,
  COMMUNITY_EXCEL_DOWN,
  COMMUNITY_FORM,
  COMMUNITYDELETE,
  COMMUNITYDETAIL,
  COMMUNITYFILEDELETE,
  COMMUNITYFILEDOWNLOAD,
  COMMUNITYFILEINSERT,
  COMMUNITYHIT,
  COMMUNITYINSERT,
  COMMUNITYLIST,
  COMMUNITYUPDATE,
  REISSUE_ACCESS_TOKEN
} from 'src/redux/actions/actionTypes';

let communityData = [];

export const mainCommunityReducer = (state = communityData, action) => {
  switch (action.type) {

    case COMMUNITY_AUTHCODE:
    case COMMUNITYDETAIL:
    case COMMUNITY_COMMNET_LIST:
    case COMMUNITYHIT:
    case COMMUNITY_CATEGORY:
    case COMMUNITYINSERT:
    case COMMUNITY_FORM:
    case COMMENT_POP:
    case COMMUNITY_EXCEL_DOWN:
      /* success */
      communityData.splice(0, communityData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        communityData.push(action.payload.data.res);
        return communityData;
      }
      return communityData;

    case COMMUNITYLIST:
      /* success */
      communityData.splice(0, communityData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        communityData.push(action.payload.data.res);
        return communityData;
      } else if (action.payload.data.resultCode !== 'S0000') {
        communityData.push(action.payload.data);
        return communityData;
      }
      return communityData;
    case REISSUE_ACCESS_TOKEN :
      communityData.splice(0, communityData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        // communityData.push(action.payload.data.res)
        sessionStorage.setItem('token', action.payload.data.res.accessToken);
        sessionStorage.setItem('refreshToken', action.payload.data.res.refreshToken);
        sessionStorage.setItem('tokenExpireTime', action.payload.data.res.tokenExpireTime);
        return communityData;
      }
      return communityData;
    case COMMUNITYUPDATE:
    case COMMUNITYDELETE:
    case COMMUNITY_COMMNET_INSERT:
    case COMMUNITY_COMMNET_UPDATE:
    case COMMUNITY_COMMNET_DELETE:
    case COMMUNITYFILEINSERT:
    case COMMUNITYFILEDELETE:
    case COMMUNITYFILEDOWNLOAD:
      communityData.splice(0, communityData.length);
      if (action.payload === undefined) {
        return communityData;
        /* SUCCESS */
      } else if (action.payload.data.resultCode === 'S0000') {
        communityData.push(action.payload.data.resultCode);
        return communityData;
      }
      break;
    default:
      return state;
  }
};
  
  